$(document).ready(function(){  

/* ==========================================================================================
   ===========================  Add to cart using ajax ======================================
   ==========================================================================================
*/
     $(document).on("click",".ajx_a2c",function(){
      
      var old = $(this).html();
      var $this = $(this);
      var product_id = $(this).data("pid");
      var old = $(this).html();
      jQuery.post('/cart/add.js', {
      quantity: 1,
      id:product_id,
      success: function(){ 
                          $this.html("<i class='fa fa-check'></i><span>Added to cart</span>");
                          setTimeout(function(){$this.html(old);},2000);
                          setTimeout(function(){
                           $.ajax({
                                 type: 'GET',
                                 url: '/cart.js',
                                 dataType: 'json',
                                 success: function(cart){
                                   
                                    $("#CartCount span").html(cart.item_count);
                                    ajaxCart.load();
                                    $('body').toggleClass("iscartpopup");
                                 }
                           });
                          },500);
                         }         
    });
    });
  
/* ==========================================================================================
   ===========================  smart search  ===============================================
   ==========================================================================================

  
  $(".search-header__input").on("keyup",function(){
    var serachVal = $(this).val();
    
    if(serachVal != '')
    {
      $(".search--suggestion").fadeIn(); 
       $.ajax({
         type: 'GET',
         url: '/admin/products.json',
         success: function(data){
         //console.log(data.products[0].id);  
        $.each( data.products , function( key, value ) {
               //alert(data.products[key].id);
               console.log(serachVal);
               if(data.products[key].title.indexOf(serachVal) != -1)
               {
                  $(".search--suggestion").append('<p>'+data.products[key].title+'</p>');
               }
            });
        }
      }); 
      
       $.ajax({
         type: 'GET',
         url: '/admin/pages.json',
         success: function(data){
         //console.log(data.products[0].id);  
        $.each( data.pages , function( key, value ) {
               //alert(data.products[key].id);
               console.log(serachVal);
               if(data.pages[key].title.indexOf(serachVal) != -1)
               {
                  $(".search--suggestion").append('<p>'+data.pages[key].title+'</p>');
               }
            });
        }
      });     
    }
    else
    {
      $(".search--suggestion").empty();
      $(".search--suggestion").fadeOut(); 
      
    }
 
  });
*/
  
});
